import * as React from "react";

function SvgArchive(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 20"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M16.91-.01h-9.8a1.2 1.2 0 00-1.22 1.26h12.25a1.21 1.21 0 00-1.23-1.26zm3.68 3.75a1.21 1.21 0 00-1.23-1.25H4.66a1.2 1.2 0 00-1.22 1.26v1.24h17.15zm2.46 1.25l-.74-.75v2H1.72v-2l-.73.75c-.74.76-1.23 1-.86 2.51s1.71 10.13 1.84 11.25a1.52 1.52 0 001.47 1.24h17.15a1.53 1.53 0 001.46-1.24c.25-1.12 1.6-9.76 1.84-11.25s-.24-1.75-.84-2.51zm-6.13 7.5a1.17 1.17 0 01-1.22 1.25H8.34a1.17 1.17 0 01-1.23-1.25v-2.5h1.23v2.5h7.35v-2.5h1.22z" />
    </svg>
  );
}

const MemoSvgArchive = React.memo(SvgArchive);
export default MemoSvgArchive;
